<template>
    <div class="ns-paginate-filter-container">
        <div class="blockFilter">
            <div
                v-if="filters.length > 0"
                :class="[allowWrap === false ? '': 'flexWrap']"
                class="blockFlex blockSelect"
            >
                <div v-if="allowedFilterKeys.length">

                    <el-row
                        :gutter="40"
                        style="width: 100%;"
                    >
                        <el-col
                            v-for="(listFilter, filterKey, index) in allowedFilter"
                            :key="filterKey"
                            :xs="selectWidth.xs || 24"
                            :sm="selectWidth.sm || 12"
                            :md="selectWidth.md || computeSelectWidth(index)"
                            :lg="selectWidth.lg || computeSelectWidth(index)"
                            :xl="selectWidth.xl || computeSelectWidth(index)"
                        >
                            <filter-select
                                ref="filterSelect"
                                :verbose="listFilter.verbose"
                                :list="listFilter.list"
                                :filters-values="filtersValue.keysFilter[filterKey]"
                                :key="filterKey"
                                :format-function="listFilter.formatFunction"
                                :defaultValue="filtersValue.keysFilter[filterKey] || listFilter.defaultValue"
                                style="margin-bottom: 15px;"
                                @valueUpdated="filtersValue.keysFilter[filterKey] = $event"
                            >
                            </filter-select>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <slot name="custom-input"></slot>
            <template v-if="displayAdvancedFilter">
                <div class="switchFilterType">
                    <el-switch
                        v-model="advancedFilter"
                        :active-text="getVerbose('ns_paginate_advanced_filters_switch_active_text')"
                    ></el-switch>
                </div>
            </template>
            <div
                v-if="advancedFilter"
                class="advancedFilter"
            >
                <el-alert
                    :closable="false"
                    :description="getVerbose('ns_paginate_advanced_filters_description')"
                    :title="getVerbose('ns_paginate_advanced_filters_title')"
                    type="info"
                    style="border: 1px solid #909399; margin-bottom: 15px;"
                    show-icon
                >
                </el-alert>
                <el-button
                    @click="addAdvancedFilter"
                    type="primary"
                    class="addAdvancedFilter"
                >
                    <i class="el-icon-plus"></i>
                </el-button>
                <div
                    v-for="(value, index) in advancedFiltersValue"
                    class="blockAddAdvancedFilter"
                    :key="index"
                >
                    <el-row :gutter="40">
                        <el-col
                            :xs="24"
                            :sm="24"
                            :md="10"
                            :lg="10"
                            :xl="10"
                        >
                            <el-select
                                :placeholder="getVerbose('ns_paginate_ns_paginate_advanced_filters_placeholder')"
                                v-model="value.valueToFilter"
                                style="width: 100%"
                                :key="index"
                            >
                                <el-option
                                    v-for="item in allowedFilterKeys"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                >
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col
                            :xs="24"
                            :sm="24"
                            :md="6"
                            :lg="6"
                            :xl="6"
                        >
                            <el-select
                                :placeholder="getVerbose('ns_paginate_advanced_filters_compare_placeholder')"
                                v-model="value.valueComparator"
                                style="width: 100%"
                            >
                                <el-option
                                    :label="getVerbose('ns_paginate_advanced_filters_compare_gt')"
                                    value="gt"
                                ></el-option>
                                <el-option
                                    :label="getVerbose('ns_paginate_advanced_filters_compare_gte')"
                                    value="gte"
                                ></el-option>
                                <el-option
                                    :label="getVerbose('ns_paginate_advanced_filters_compare_lt')"
                                    value="lt"
                                ></el-option>
                                <el-option
                                    :label="getVerbose('ns_paginate_advanced_filters_compare_lte')"
                                    value="lte"
                                ></el-option>
                                <el-option
                                    :label="getVerbose('ns_paginate_advanced_filters_compare_range')"
                                    value="range"
                                ></el-option>
                            </el-select>
                        </el-col>
                        <el-col
                            :xs="24"
                            :sm="24"
                            :md="5"
                            :lg="5"
                            :xl="5"
                        >
                            <el-input
                                v-model="value.targetValue"
                                :placeholder="getVerbose('ns_paginate_advanced_filters_compare_input_placeholder')"
                                style="width: 100%"
                            >
                            </el-input>
                            <div
                                v-if="value.valueComparator === 'range'"
                                class="rangeTip"
                            >{{ getVerbose('ns_paginate_advanced_filters_compare_input_tip') }}</div>
                        </el-col>
                        <el-col :span="2">
                            <el-button
                                icon="el-icon-delete"
                                @click="deleteAdvancedFiltersValue(index)"
                                class="deleteAdvancedFiltersValue"
                            >
                            </el-button>
                        </el-col>
                        <el-col :span="24">
                            <p
                                class="helpFilter"
                                ref="helpFilter"
                            ></p>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div
            class="blockButtons"
        >
            <el-button
                :icon="windowWidth < 446 ? 'el-icon-refresh-left': ''"
                class="reset-button"
                @click="resetFilters()"
            >
                <span v-if="windowWidth > 445">{{ getVerbose('new_ns_paginate_filters_button_reset') }}</span>
            </el-button>
            <el-button
                :icon="windowWidth < 446 ? 'el-icon-check': ''"
                class="apply-button"
                type="primary"
                @click="loadContent()"
            >
                <span v-if="windowWidth > 445">{{ getVerbose('new_ns_paginate_filters_button_apply') }}</span>
            </el-button>
        </div>




    </div>
</template>

<script>

import { mapGetters } from 'vuex';
import filterSelect from './filter-select.vue';

export default {

    components: {
        filterSelect
    },

    props: {
        searchText: {
            type: String,
            default: undefined
        },
        allowedFilter: {
            type: Object,
            required: true
        },
        filtersValue: {
            type: Object,
            required: true
        },
        filters: {
            type: Array,
            required: true
        },
        allowWrap: {
            type: Boolean,
            required: true
        },
        selectWidth: {
            type: Object,
            required: true
        },
        displayAdvancedFilter: {
            type: Boolean,
            required: true
        },
        advancedFilter: {
            type: Boolean,
            required: true
        },
        windowWidth: {
            type: Number,
            required: true
        },

    },

    data: function(){
        return {
            advancedFiltersValue: [{
                valueToFilter: null,
                valueComparator: null,
                targetValue: null,
            }],
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'getVerbose'
        ]),
        allowedFilterKeys() {
            return Object.keys(this.allowedFilter);
        }

    },

    mounted: function(){
    },

    methods: {
        computeSelectWidth(key) {
            if (this.allowedFilterKeys.length - (Math.trunc(key/3) * 3) > 6) {
                return 8;
            }
            else {
                // cas particuliers (5 et 1)
                if (this.allowedFilterKeys.length - (Math.trunc(key/3) * 3) === 5) {
                    if (key >= this.allowedFilterKeys.length - 2) {
                        return 12;
                    }
                    return 8;
                }
                if (this.allowedFilterKeys.length === 1) {
                    return 24;
                }
                return (this.allowedFilterKeys.length - (Math.trunc(key/3) * 3)) % 3 === 0 ? 8 : 12;
            }
        },
        addAdvancedFilter() {
            this.advancedFiltersValue.push({
                valueToFilter: null,
                valueComparator: null,
                targetValue: null,
            });
        },
        resetFilters() {
            this.$emit('resetFilters');
        },
        loadContent() {
            this.$emit('loadContent');
        },

    },
};
</script>

<style lang="scss">

.ns-paginate-filter-container {
    margin: 0 30px 30px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    background-color: #F9F9F9;
    .blockFilter {
        width: 80%;
    }
    .blockButtons {
        width: 20%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        .el-button {
            margin-bottom: 15px;
        }
        .reset-button {
            border: none;
            box-shadow: 0px 1px 4px rgba(207, 206, 207, 0.25);
        }
        .apply-button {
            box-shadow: 0px 1px 4px rgba(207, 206, 207, 0.25);
            background-color: #409EFF;
        }
    }

}

</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/partials/nsPaginate2/-new-ns-paginate-filters.vue